import { persist } from 'mobx-persist/lib/index';
import { observable } from 'mobx/lib/mobx';

export class AppUserDataSchema {
    @persist('object') @observable homedetails = {};
    @persist('object') @observable floorarea = {};
    @persist('object') @observable rooms = {};
}
